import axios from 'axios';
import {
  FETCH_REFERRALS_SUCCESS,
  FETCH_REFERRALS_FAIL,
} from './types';

export const fetchReferrals = (params) => async (dispatch) => {
  const url = process.env.REACT_APP_API_URL + '/private/referrals';
  try {
    const response = await axios.get(url, { params });
    return dispatch({ type: FETCH_REFERRALS_SUCCESS, payload: response.data.data });
  } catch (error) {
    if (error) {
      return dispatch({ type: FETCH_REFERRALS_FAIL, errors: error });
    }

    return dispatch({ type: FETCH_REFERRALS_FAIL });
  }
};
